import { FormulaSheetEntry } from 'common/src/formulaSheet/types'
import { atom, selector } from 'recoil'
import { getFormulaSheetEntries } from '@/api/cb/contentCreatorContent'
import { frontendDisplayedCourseSelector } from '@/atoms/auth'
import { Set } from 'immutable'
import { isEqual } from 'lodash'

export const formulaSheetEntriesInvalidatorAtom = atom<number>({
    key: 'formulaSheetEntriesInvalidatorAtom',
    default: 0,
})

export const formulaSheetEntriesAtom = atom<FormulaSheetEntry[]>({
    key: 'formulaSheetEntriesAtom',
    default: selector<FormulaSheetEntry[]>({
        key: 'formulaSheetEntriesFetcher',
        get: async ({ get }) => {
            get(formulaSheetEntriesInvalidatorAtom)
            return (
                await getFormulaSheetEntries(
                    get(frontendDisplayedCourseSelector)
                )
            ).data.payload.formulaSheetEntries
        },
    }),
})

export const autoOpenFormulaSheetEntryIdAtom = atom<string | null>({
    key: 'autoOpenFormulaSheetEntryIdAtom',
    default: null,
})

export const lastSavedFormulaSheetEntriesAtom = atom<FormulaSheetEntry[]>({
    key: 'lastSavedFormulaSheetEntriesAtom',
    default: [],
})

export const formulaSheetEntriesHaveUnsavedChangesSelector = selector<boolean>({
    key: 'formulaSheetEntriesHaveUnsavedChangesSelector',
    get: ({ get }) => {
        const entries = get(formulaSheetEntriesAtom)
        const lastSavedEntries = get(lastSavedFormulaSheetEntriesAtom)
        return (
            get(formulaSheetEntriesWithUnsavedChangesSelector).size > 0 ||
            !isEqual(
                entries.map((entry) => entry.id),
                lastSavedEntries.map((entry) => entry.id)
            )
        )
    },
})

export const formulaSheetEntriesWithUnsavedChangesSelector = selector<
    Set<string>
>({
    key: 'formulaSheetEntriesWithUnsavedChangesSelector',
    get: ({ get }) => {
        const lastSavedById = new Map(
            get(lastSavedFormulaSheetEntriesAtom).map((entry) => [
                entry.id,
                entry,
            ])
        )
        let result = Set<string>()
        for (const formulaSheetEntry of get(formulaSheetEntriesAtom)) {
            if (
                !isEqual(
                    formulaSheetEntry,
                    lastSavedById.get(formulaSheetEntry.id)
                )
            ) {
                result = result.add(formulaSheetEntry.id)
            }
        }
        return result
    },
})
